import { logEvent } from "@src/appV2/lib/analytics";
import { REFERRAL_POST_CLOCK_OUT_CTA_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { Button } from "@src/appV2/redesign/components/Button";
import { WORKER_REFERRALS_SHARE_LINK_PATH_FULL } from "@src/appV2/Referral/path";
import { useHistory, useLocation } from "react-router-dom";

import { useReferralPostClockOutCta } from "./useReferralPostClockOutCta";

interface ReferralPostClockOutCtaProps {
  shiftId: string;
  workplaceId: string;
  workplaceType: string | undefined;
}

export function ReferralPostClockOutCta(props: ReferralPostClockOutCtaProps) {
  const { shiftId, workplaceId, workplaceType } = props;
  const history = useHistory();
  const location = useLocation();

  const { isEligible, msa } = useReferralPostClockOutCta({ workplaceId, workplaceType });

  const eventProperties = { shiftId, workplaceId, workplaceType, msa };

  useLogEffect(
    REFERRAL_POST_CLOCK_OUT_CTA_EVENTS.REFERRAL_POST_CLOCK_OUT_CTA_VIEWED,
    eventProperties,
    {
      enabled: isEligible,
    }
  );

  if (!isEligible) {
    return null;
  }

  return (
    <Button
      fullWidth
      variant="outlined"
      size="large"
      onClick={() => {
        logEvent(
          REFERRAL_POST_CLOCK_OUT_CTA_EVENTS.REFERRAL_POST_CLOCK_OUT_CTA_CLICKED,
          eventProperties
        );
        history.replace(location.pathname, { reopenEarningsModal: true });
        history.push(WORKER_REFERRALS_SHARE_LINK_PATH_FULL);
      }}
    >
      Refer a friend, earn $150
    </Button>
  );
}
